const createMediaQuery = n => `@media screen and (min-width:${n})`;

const addAliases = (arr, aliases) =>
  aliases.forEach((key, i) =>
    Object.defineProperty(arr, key, {
      enumerable: false,
      get() {
        return this[i];
      },
    })
  );

export const breakpoints = [32, 48, 64].map(n => n + 'em');

export const mediaQueries = breakpoints.map(createMediaQuery);

const aliases = ['sm', 'md', 'lg', 'xl'];

addAliases(breakpoints, aliases);
addAliases(mediaQueries, aliases);

export const colors = {
  battleshipGrey: '#727585',
  silver: '#dddee2',
  almostBlack: '#2b2c3d',
  almostWhite: '#f5f5f6',
  orange: '#f59b24',
  darkOrange: '#eb730b',
  almostRed: '#e14d62',
  paleOrange: '#ffd68f',
  greenish: '#07a87e',
  darkPerriwinkle: '#6473dc',
  yellowSnow: '#fff2da',
  white: '#ffffff',
  palePerriwinkle: '#d4d8f5',

  facebookBlue: '#4267b2',
};

export const color = colors.almostRed;

export const font = `'Glober', 'Helvetica', 'Arial', 'sans-serif'`;
export const fontSizes = [
  10,
  12,
  13,
  14,
  15,
  16,
  18,
  20,
  21,
  22,
  24,
  26,
  28,
  32,
  36,
  48,
  52,
];
export const medium = 500;
export const bold = 700;

export const fontWeights = {
  medium,
  bold,
};

export const lineHeights = {
  standard: 1.5,
  display: 1.25,
};

const letterSpacings = {
  normal: 'normal',
  caps: '0.025em',
};

const fonts = {
  heading: 'Glober, Helvetica, Arial, sans-serif',
  body: 'Glober, Helvetica, Arial, sans-serif',
  code: 'Roboto Mono, monospace',
  quote: 'Playfair Display, serif',
};

export const textStyles = {
  canon: {
    tag: 'h1',
    fontSize: [11, 12, 14],
    fontWeight: 700,
    lineHeight: ['32px', '36px', '56px'],
    // fontFamily: fontFamilies.heading,
  },
  trafalgar: {
    tag: 'h1',
    fontSize: [6, 9, 12],
    lineHeight: ['24px', '28px', '40px'],
    fontWeight: 500,
    // fontFamily: fontFamilies.heading,
  },
  paragon: {
    tag: 'h2',
    fontSize: [6, 8, 11],
    fontWeight: 500,
    // fontFamily: fontFamilies.heading,
    lineHeight: ['20px', '26px', '32px'],
  },
  doublePica: {
    fontSize: [6, 6, 10],
    fontWeight: 400,
    // fontFamily: fontFamilies.heading,
    lineHeight: ['24px', '24px', '30px'],
  },
  greatPrimer: {
    tag: 'h3',
    fontWeight: 400,
    fontSize: [5, 5, 7],
    // fontFamily: fontFamilies.heading,
    lineHeight: ['22px', '22px', '24px'],
  },
  bodyCopy: {
    tag: 'p',
    fontSize: [3, 4, 5],
    // fontFamily: fontFamilies.body,
    lineHeight: ['20px', '22px', '24px'],
  },
  code: {
    tag: 'span',
    px: '4px',
    py: '2px',
    lineHeight: '22px',
    color: colors.battleshipGrey,
    bg: colors.silver,
    borderRadius: 4,
    // fontFamily: fontFamilies.code,
  },
  underline: {
    textDecoration: 'underline',
  },
};

export const space = [0, 4, 8, 16, 32, 64, 128, 256, 512];

export const radii = [0, 2, 6];
export const radius = '2px';

export const maxContainerWidth = '1280px';

// boxShadows
export const shadows = [
  `0 0 2px 0 rgba(0,0,0,.08),0 1px 4px 0 rgba(0,0,0,.16)`,
  `0 0 2px 0 rgba(0,0,0,.08),0 2px 8px 0 rgba(0,0,0,.16)`,
  `0 0 2px 0 rgba(0,0,0,.08),0 4px 16px 0 rgba(0,0,0,.16)`,
  `0 0 2px 0 rgba(0,0,0,.08),0 8px 32px 0 rgba(0,0,0,.16)`,
];

// animation duration
export const duration = {
  fast: `150ms`,
  normal: `300ms`,
  slow: `450ms`,
  slowest: `600ms`,
};

// animation easing curves
const easeInOut = 'cubic-bezier(0.5, 0, 0.25, 1)';
const easeOut = 'cubic-bezier(0, 0, 0.25, 1)';
const easeIn = 'cubic-bezier(0.5, 0, 1, 1)';

const timingFunctions = {
  easeInOut,
  easeOut,
  easeIn,
};

// animation delay
const transitionDelays = {
  small: `60ms`,
  medium: `160ms`,
  large: `260ms`,
  xLarge: `360ms`,
};

const theme = {
  breakpoints,
  mediaQueries,
  space,
  font,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  bold,
  textStyles,
  colors,
  // colorStyles,
  radii,
  radius,
  shadows,
  maxContainerWidth,
  duration,
  timingFunctions,
  transitionDelays,
};

export default theme;

// export default {
//   // textStyles: {
//   //   canon: {
//   //     tag: 'h1',
//   //     fontSize: [11, 12, 14],
//   //     fontWeight: 700,
//   //     lineHeight: ['32px', '36px', '56px'],
//   //     fontFamily: fontFamilies.heading,
//   //   },
//   //   trafalgar: {
//   //     tag: 'h1',
//   //     fontSize: [6, 9, 12],
//   //     lineHeight: ['24px', '28px', '40px'],
//   //     fontWeight: 500,
//   //     fontFamily: fontFamilies.heading,
//   //   },
//   //   paragon: {
//   //     tag: 'h2',
//   //     fontSize: [6, 8, 11],
//   //     fontWeight: 500,
//   //     fontFamily: fontFamilies.heading,
//   //     lineHeight: ['20px', '26px', '32px'],
//   //   },
//   //   doublePica: {
//   //     fontSize: [6, 6, 10],
//   //     fontWeight: 400,
//   //     fontFamily: fontFamilies.heading,
//   //     lineHeight: ['24px', '24px', '30px'],
//   //   },
//   //   greatPrimer: {
//   //     tag: 'h3',
//   //     fontWeight: 400,
//   //     fontSize: [5, 5, 7],
//   //     fontFamily: fontFamilies.heading,
//   //     lineHeight: ['22px', '22px', '24px'],
//   //   },
//   //   bodyCopy: {
//   //     tag: 'p',
//   //     fontSize: [3, 4, 5],
//   //     fontFamily: fontFamilies.body,
//   //     lineHeight: ['20px', '22px', '24px'],
//   //   },
//   //   code: {
//   //     tag: 'span',
//   //     px: '4px',
//   //     py: '2px',
//   //     lineHeight: '22px',
//   //     color: colors.battleshipGrey,
//   //     bg: colors.silver,
//   //     borderRadius: 4,
//   //     fontFamily: fontFamilies.code,
//   //   },
//   //   underline: {
//   //     textDecoration: 'underline',
//   //   },
//   // },
//   fontFamily: ['Glober', 'Helvetica', 'Arial', 'sans-serif'],

//   fontSizes: [
//     10,
//     12,
//     13,
//     14,
//     15,
//     16,
//     18,
//     20,
//     21,
//     22,
//     24,
//     26,
//     28,
//     32,
//     36,
//     48,
//     52,
//   ],
//   lineHeights: [
//     '18px',
//     '24px',
//     '30px',
//     '36px',
//     '42px',
//     '48px',
//     '54px',
//     '60px',
//     '66px',
//   ],
//   breakpoints: ['425px', '768px', '1024px', '1440px'],
//   color: colors.almostRed,
//   colors: {
//     ...colors,
//   },
//   space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
// };
